// Module
var code = `<div class="interface"> </div>`;
// Exports
export default code;